import { Injectable } from '@angular/core';
import { CategoriesService } from '../../../../../../data-services/categories.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class CategoriesOptionsDisplayService implements DataFilterDisplayService {
  constructor(private categoriesService: CategoriesService) {}
  getDisplay(value: string[]): Observable<string> {
    return this.categoriesService
      .getNamesFromCategoryIDs(value)
      .pipe(map((categoryNames) => `<b>${categoryNames.join(', ')}</b>`));
  }
}
